import { createApp } from "vue";
import App from "./App.vue";
import { i18n } from "./plugins/i18n";
import getLocale from "./locale";

const locale_config = getLocale();
i18n.global.locale = locale_config;

createApp(App).use(i18n).mount("#app");
